"use client";

import { useQuery } from "urql";
import {
  FindPagesDocument,
  HierarchyEntityResponse,
  Maybe,
  PageEntity,
  TagRelationResponseCollection,
} from "@/graphql/generated/graphql";
import { useLocale } from "./useLocale";
import { notEmpty } from "./notEmpty";

export function usePagePreview({
  limit,
  hierarchy,
  tags,
  pause,
}: {
  limit: number;
  hierarchy: Maybe<HierarchyEntityResponse> | undefined;
  tags: Maybe<TagRelationResponseCollection> | undefined;
  pause?: boolean;
}): { loadedPages: PageEntity[] } {
  const { locale } = useLocale();
  const hierarchyIds =
    ((hierarchy?.data?.id && [
      hierarchy?.data?.id,
      ...(hierarchy?.data?.childIds || []),
    ]) as string[]) || [];
  const tagIds =
    (tags?.data?.filter(notEmpty).map((t) => t.id) as string[]) || [];

  console.log({ hierarchyIds, tagIds, locale });

  const [{ fetching, data, error }] = useQuery({
    query: FindPagesDocument,
    pause: (hierarchyIds.length === 0 && tagIds.length === 0) || pause,
    variables: {
      limit,
      locale,
      start: 0,
      tags: tagIds?.length > 0 ? tagIds : undefined,
      hierarchyIds: hierarchyIds?.length > 0 ? hierarchyIds : undefined,
    },
  });

  console.log("data", data);

  return {
    loadedPages: (data?.pages?.data || []) as PageEntity[],
  };
}
